import { use } from 'react';

// auth provider
import JWTAuthContext from 'contexts/JWTContext';
// import AuthContext from 'contexts/FirebaseContext';
//import Auth0Context from 'contexts/Auth0Context';
import {TARGET_APP_BUILD, TARGET_APP_BUILD_VALUE} from "@/constants/globalConstants";
// import AuthContext from 'contexts/AWSCognitoContext';
// import AuthContext from 'contexts/SupabaseContext';
import DirectContext from '@/contexts/DirectJWTContext'

// ==============================|| AUTH HOOKS ||============================== //

export default function useAuth() {
  const context = use(TARGET_APP_BUILD === TARGET_APP_BUILD_VALUE.BACKUP ? DirectContext : JWTAuthContext);

  if (!context) throw new Error('context must be use inside provider');

  return context;
}
